
import { useState, createContext, useEffect } from 'react';
import utilsMaster from '../Connections/_Utils/utilsMaster';

export const SideMenuContext = createContext();

export const SideMenuContextProvider = (props) => {

    const [sideMenucon, setSideMenucon] = useState();

    useEffect(() => {
        if (!sideMenucon) {
            getMenu();
        }
    }, [sideMenucon]);

    const getMenu = async () => {
        try {
            const theMenu = await utilsMaster.getMainMenu();            
            setSideMenucon(theMenu);
        } catch (error) {
            console.error('Error fetching the menu:', error);
        }
    };





    return (
        <SideMenuContext.Provider value={[sideMenucon, setSideMenucon]}>
            {props.children}
        </SideMenuContext.Provider>
    );
};
